import { TierRateByYear } from './../../interfaces';

export const rates: TierRateByYear = {
    2018: [ { base: 7_280 } ],
    2019: [ { base: 7_280 } ],
    2020: [ { base: 7_030 } ],
    2021: [ { base: 6_670 } ],
    2022: [ { base: 6_310 } ],
    2023: [ { base: 5_030 } ],
    2024: [ { base: 3_750 } ]
};
